import React from 'react'
import { Icon } from "@blueprintjs/core";
import Image from '../Image';
import { Translate } from "react-redux-i18n";

const GiftCard=({suggestion, handleSuggestionClick})=>{
    return (
        <div className="gift-item" onClick={_=>handleSuggestionClick(suggestion)} >
            <div className="gift-image">
                <Image src={suggestion.images[0].url} alt={suggestion.name} />
            </div>
            <div className="gift-group">
                <Icon icon="people" />
                &nbsp;{suggestion.suggested_members_no}&nbsp;
                <Translate value="whitemonday.landing_whitemonday.people" />
            </div>
            <div className="gift-name">
                <h2>{suggestion.short_description}</h2>
            </div>
        </div>
    )
}

export default GiftCard;